/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 2/27/15,
 * Refactored by kyang on 9/24/20
 */

function LoginController (
    this: JS5Object,
    _: JS5Object,
    $window: JS5Object,
    LoginEditService: JS5Object,
    EchoService: JS5Object,
    SamlResourceFactory: JS5Object,
    Rx: JS5Object,
) {
    const updateServerStatus = (newServerStatus: JS5Object) => {
        if (newServerStatus.serverResponded) {
            LoginEditService.removeError('serverDown');
            this.serverDown = false;
        } else { // If server didn't respond yet...
            if (newServerStatus.response === undefined) {
                LoginEditService.setError('serverDown', 'Checking server status...');
            } else { // and server failed to respond...
                LoginEditService.setError('serverDown', 'Cannot login.  Failed to connect to the server.');
                console.error('Failed to connect to the server. Response:');
                console.error(newServerStatus.response);
                LoginEditService.serverDown = true;
            }
        }
    };

    this.toggleLoginType = () => {
        if (this.isSamlEnabled && this.loginType !== 'saml') {
            this.loginType = 'saml';
        } else {
            this.loginType = 'system';
        }
    };

    this.getTopLogo = () => {
        return {
            href: $window.__wfcConfig.topLogoHref,
            width: $window.__wfcConfig.topLogoWidth,
            height: $window.__wfcConfig.topLogoHeight,
        };
    };

    this.getBottomLogo = () => {
        return {
            href: $window.__wfcConfig.bottomLogoHref,
            width: $window.__wfcConfig.bottomLogoWidth,
            height: $window.__wfcConfig.bottomLogoHeight,
        };
    };


    //=================//
	// Lifecycle Hooks //
    //=================//

    const onErrorsChanged = (errors: JS5Object) => {
        this.errors = errors;
    };

    this.$onInit = () => {
        this.destroyObservable = new Rx.Subject();
        this.serverDown = false; // Let user try to login before server status is verified
        SamlResourceFactory.isSamlEnabled().$promise
            .then((enabledResponse: JS5Object) => {
                this.isSamlEnabled = enabledResponse.isSamlEnabled;
            })
            .finally(() => {
                this.loginType = (this.isSamlEnabled) ? 'saml' : 'system';
            });
        LoginEditService.errorObservable
            .takeUntil(this.destroyObservable)
            .subscribeOnNext(onErrorsChanged);
        EchoService.initialize();
        EchoService.registerDataUpdateCallback(updateServerStatus);
    };

    this.$onDestroy = () => {
        this.destroyObservable.onCompleted();
        EchoService.unregisterDataUpdateCallback(updateServerStatus);
    };
}

angular
.module('prism-ui.login')
.component('login', {
	controller: LoginController,
	templateUrl: 'login/login-template.html',
	bindings: {}
});
